import { ComponentType } from 'react';
import { AnimatedIconProps } from './AnimatedIcon.types';
import CheckmarkAnimation from './library/CheckmarkAnimation';

export enum ANIMATED_ICON {
  CheckMark = 'CheckMark',
}

export const ANIMATED_ICON_MAP: Record<ANIMATED_ICON, ComponentType<AnimatedIconProps>> = {
  [ANIMATED_ICON.CheckMark]: CheckmarkAnimation,
};
